import { Establishment } from '../../../../hooks/use-establishments';

export enum CHECKLISTS {
	moped = 'Brommmer',
	motor = 'Motor',
	car = 'Auto',
	carTrailer = 'Auto met aanhanger',
	truck = 'Vrachtauto',
	truckTrailer = 'Vrachtauto met aanhanger',
	bus = 'Bus',
	busTrailer = 'Bus met aanhanger',
	tractor = 'Tractor',
}

type StudentChecklist = {
	student: {
		id: number;
		firstName: string;
		lastName: string;
		initials: string | null;
		establishment: { id: number };
	};
	values: StudentChecklistValue[];
};

export type MopedChecklistType = {
	name: CHECKLISTS.moped;
	checklists: StudentChecklist[];
};

export type MotorChecklistType = {
	name: CHECKLISTS.motor;
	checklists: StudentChecklist[];
};

export type CarChecklistType = {
	name: CHECKLISTS.car;
	checklists: StudentChecklist[];
};

export type CarTrailerChecklistType = {
	name: CHECKLISTS.carTrailer;
	checklists: StudentChecklist[];
};

export type TruckChecklistType = {
	name: CHECKLISTS.truck;
	checklists: StudentChecklist[];
};

export type TruckTrailerChecklistType = {
	name: CHECKLISTS.truckTrailer;
	checklists: StudentChecklist[];
};

export type BusChecklistType = {
	name: CHECKLISTS.bus;
	checklists: StudentChecklist[];
};

export type BusTrailerChecklistType = {
	name: CHECKLISTS.busTrailer;
	checklists: StudentChecklist[];
};

export type TractorChecklistType = {
	name: CHECKLISTS.tractor;
	checklists: StudentChecklist[];
};

export type ChecklistType =
	| MopedChecklistType
	| MotorChecklistType
	| CarChecklistType
	| CarTrailerChecklistType
	| TruckChecklistType
	| TruckTrailerChecklistType
	| BusChecklistType
	| BusTrailerChecklistType
	| TractorChecklistType;

export type StudentChecklistValue = {
	option: {
		type: string;
		name:
			| 'Theorie-examen'
			| 'Praktijkexamen'
			| 'Gezondheidsverklaring'
			| 'AVB'
			| 'AVD'
			| 'Tussentijdse toets'
			| 'Medische Keuring'
			| 'RVM1 C'
			| 'VM2 C'
			| 'VM3 C'
			| 'Besloten Terrein'
			| 'Praktische Toets'
			| 'RVM1 D'
			| 'VM2 D'
			| 'VM3 D';
	};
	position: number;
	value: { checked?: boolean; examDate?: string; examResult?: boolean; authorized?: 1 | 0 };
};

export interface ChecklistDataEntry {
	student: {
		id: number;
		firstName: string;
		lastName: string;
		initials: string | null;
		establishment: Establishment;
	};
}
